"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import e from "../components/Icon/SvgIcon.js";
const l = (t) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.64 7.25c-1.048 0-1.9.896-1.9 2 0 1.102.852 2 1.9 2 1.046 0 1.898-.898 1.898-2 0-1.104-.852-2-1.899-2m0 5.25c-1.737 0-3.15-1.459-3.15-3.25C4.49 7.457 5.903 6 7.64 6c1.735 0 3.148 1.457 3.148 3.25 0 1.791-1.413 3.25-3.149 3.25m13.735-2.73h-5.977a.625.625 0 0 1 0-1.25h5.977a.625.625 0 1 1 0 1.25m-1.8 6.351h-4.177a.625.625 0 0 1 0-1.25h4.178a.626.626 0 0 1 0 1.25m-4.177-3.2h5.977a.625.625 0 1 0 0-1.25h-5.977a.625.625 0 0 0 0 1.25m-3.369 5.095a.625.625 0 1 0 1.25 0v-1.86c0-1.595-1.259-2.892-2.807-2.892H4.806C3.258 13.264 2 14.56 2 16.157v1.859a.625.625 0 1 0 1.25 0v-1.86c0-.906.698-1.642 1.556-1.642h5.666c.859 0 1.557.736 1.557 1.643z",
        clipRule: "evenodd"
      }
    )
  }
), i = c(l);
export {
  i as AccountDetails,
  i as default
};
